<template>
  <div>
  <v-app-bar color="#323232" flat app dark>
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title>{{title}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-on:click="refresh" icon>
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <template v-if="tabsActive" v-slot:extension>
      <slot></slot>
    </template>
  </v-app-bar>

  <v-navigation-drawer v-model="drawer" fixed temporary>
    <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar color="#faa619">
            <v-icon dark>mdi-account-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{username}}</v-list-item-title>
            <v-list-item-subtitle>Angemeldet</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list-item v-on:click="showMissingCounts">
          <v-list-item-content>
            <v-list-item-title>
              <span>Fehlbestände</span>
              <v-chip small dark class="ma-2" color="#faa619">{{missingCounts.length}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="#faa619" v-on:click="logout"  dark>Abmelden</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import authService from "../services/authService";
import picklistService from "../services/picklistService";
export default {
  name: "Navigation",
  props: [
    "title",
    "tabsActive"
  ],
  data () {
    return {
      drawer: false,
    }
  },
  computed: mapState({
    username: state => state.auth.realname,
    missingCounts: state => state.missingCounts,
  }),
  methods: {
    logout() {
      const that = this;
      authService.logout().then(() => {
        that.$router.push("/login");
      });
    },

    showMissingCounts() {
      this.$router.push("/missingcounts");
    },

    refresh() {
      picklistService.picklist();
    }

  }
};
</script>

<style scoped>
.user {
  margin: 0 20px;
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #faa619;
}

.navigation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>